import React, { Component } from "react";
import RankingRows from "./RankingRows.js"
import {Form, FormGroup, Label, Input, Col} from 'reactstrap';
import AdChitika from "../Ads/AdChitika";

class Rankings extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      cardType:"None",
      data: "Overall2018"
    }

      this.cardTypeChange = this.cardTypeChange.bind(this);

  }

  cardTypeChange(event) {
    this.setState({data: event.target.value})
  }

  render() {

    var homeStyle = {
      paddingTop: "65px"
    };


    var h3Style = {
      fontFamily: "Audiowide, cursive",
      color: "cadetblue"
    }

    var comingSoonStyle = {
       paddingTop: 10,
       paddingBottom: 10,
       marginTop: 10,
       marginBottom: 10,
       backgroundColor: "black",
       borderStyle: "solid",
       borderColor: "darkslategray"

    }

    var deckListStyle = {
        justifyContent: "center"
    };

    var deckStyle = {
      backgroundColor: "darkslategray",
      color: "white"

    }

    var adStyle={
      justifyContent: "center"
    }

    return (

      <div className="Site-content" style={homeStyle} >
      <div style={adStyle} className="row">
      <AdChitika publisher="Gaztingo" />
      </div>
        <div className="container  rounded" style={comingSoonStyle} >

        <div className="row justify-content-center">
        <h3 style={h3Style}>Hall of Nova</h3>
        </div>
        <div className="row justify-content-center">
        <Form inline>
        <FormGroup className="mb-2 mr-sm-2 mb-sm-2 mr-1 mb-md-2 mb-lg-2 mb-xl-2">
            <Label className="ml-2 mr-sm-2" style={h3Style}>Leaderboard</Label>
            <Input type="select" id="sCardType" value={this.state.data} onChange={this.cardTypeChange} bsSize="sm" >
                <option value="Overall2018">Overall 2018</option>
                <option value="January2018">January 2018</option>
                <option value="February2018">February 2018</option>
                <option value="March2018">March 2018</option>
                <option value="April2018">April 2018</option>
                <option value="May2018">May 2018</option>
            </Input>
          </FormGroup>
          </Form>
          </div>
        </div>


      <div className="container">
      <div id="deck" className="d-flex flex-row flex-wrap" style={deckListStyle} >

          <table id="decklist" style={deckStyle} className="table table-sm">
              <thead>
                  <tr>
                    <th>Rank</th>
                    <th>Player</th>
                    <th>Points</th>
                  </tr>
              </thead>
              <tbody>
                <RankingRows data={this.state.data} />
              </tbody>
              <tfoot>
              </tfoot>
          </table>


      </div>
      </div>
    </div>
    );
  }
}

export default Rankings;



// WEBPACK FOOTER //
// ./src/LeaderBoard/Rankings.js